import { baseUrl } from "../../../config.js";
import { EventBus } from "../../../eventbus";
import { setDocTitle } from "../../../functions/HelperFuncs.js";

const company_fields = [
  {
    label: "Architecture",
    value: "architecture",
  },
  {
    label: "Digital & IT",
    value: "digital",
  },
  {
    label: "Hospitality",
    value: "hospitality",
  },
  {
    label: "Interior design",
    value: "interior design",
  },
  {
    label: "Press",
    value: "press",
  },
  {
    label: "Retail",
    value: "retail",
  },
  {
    label: "Other",
    value: "other",
  },
];

const countries = [
  { label: "Afghanistan", value: "AF" },
  { label: "Åland Islands", value: "AX" },
  { label: "Albania", value: "AL" },
  { label: "Algeria", value: "DZ" },
  { label: "American Samoa", value: "AS" },
  { label: "Andorra", value: "AD" },
  { label: "Angola", value: "AO" },
  { label: "Anguilla", value: "AI" },
  { label: "Antarctica", value: "AQ" },
  { label: "Antigua and Barbuda", value: "AG" },
  { label: "Argentina", value: "AR" },
  { label: "Armenia", value: "AM" },
  { label: "Aruba", value: "AW" },
  { label: "Australia", value: "AU" },
  { label: "Austria", value: "AT" },
  { label: "Azerbaijan", value: "AZ" },
  { label: "Bahrain", value: "BH" },
  { label: "Bahamas", value: "BS" },
  { label: "Bangladesh", value: "BD" },
  { label: "Barbados", value: "BB" },
  { label: "Belarus", value: "BY" },
  { label: "Belgium", value: "BE" },
  { label: "Belize", value: "BZ" },
  { label: "Benin", value: "BJ" },
  { label: "Bermuda", value: "BM" },
  { label: "Bhutan", value: "BT" },
  { label: "Bolivia, Plurinational State of", value: "BO" },
  { label: "Bonaire, Sint Eustatius and Saba", value: "BQ" },
  { label: "Bosnia and Herzegovina", value: "BA" },
  { label: "Botswana", value: "BW" },
  { label: "Bouvet Island", value: "BV" },
  { label: "Brazil", value: "BR" },
  { label: "British Indian Ocean Territory", value: "IO" },
  { label: "Brunei Darussalam", value: "BN" },
  { label: "Bulgaria", value: "BG" },
  { label: "Burkina Faso", value: "BF" },
  { label: "Burundi", value: "BI" },
  { label: "Cambodia", value: "KH" },
  { label: "Cameroon", value: "CM" },
  { label: "Canada", value: "CA" },
  { label: "Cape Verde", value: "CV" },
  { label: "Cayman Islands", value: "KY" },
  { label: "Central African Republic", value: "CF" },
  { label: "Chad", value: "TD" },
  { label: "Chile", value: "CL" },
  { label: "China", value: "CN" },
  { label: "Christmas Island", value: "CX" },
  { label: "Cocos (Keeling) Islands", value: "CC" },
  { label: "Colombia", value: "CO" },
  { label: "Comoros", value: "KM" },
  { label: "Congo", value: "CG" },
  { label: "Congo, the Democratic Republic of the", value: "CD" },
  { label: "Cook Islands", value: "CK" },
  { label: "Costa Rica", value: "CR" },
  { label: "Côte d'Ivoire", value: "CI" },
  { label: "Croatia", value: "HR" },
  { label: "Cuba", value: "CU" },
  { label: "Curaçao", value: "CW" },
  { label: "Cyprus", value: "CY" },
  { label: "Czech Republic", value: "CZ" },
  { label: "Denmark", value: "DK" },
  { label: "Djibouti", value: "DJ" },
  { label: "Dominica", value: "DM" },
  { label: "Dominican Republic", value: "DO" },
  { label: "Ecuador", value: "EC" },
  { label: "Egypt", value: "EG" },
  { label: "El Salvador", value: "SV" },
  { label: "Equatorial Guinea", value: "GQ" },
  { label: "Eritrea", value: "ER" },
  { label: "Estonia", value: "EE" },
  { label: "Ethiopia", value: "ET" },
  { label: "Falkland Islands (Malvinas)", value: "FK" },
  { label: "Faroe Islands", value: "FO" },
  { label: "Fiji", value: "FJ" },
  { label: "Finland", value: "FI" },
  { label: "France", value: "FR" },
  { label: "French Guiana", value: "GF" },
  { label: "French Polynesia", value: "PF" },
  { label: "French Southern Territories", value: "TF" },
  { label: "Gabon", value: "GA" },
  { label: "Gambia", value: "GM" },
  { label: "Georgia", value: "GE" },
  { label: "Germany", value: "DE" },
  { label: "Ghana", value: "GH" },
  { label: "Gibraltar", value: "GI" },
  { label: "Greece", value: "GR" },
  { label: "Greenland", value: "GL" },
  { label: "Grenada", value: "GD" },
  { label: "Guadeloupe", value: "GP" },
  { label: "Guam", value: "GU" },
  { label: "Guatemala", value: "GT" },
  { label: "Guernsey", value: "GG" },
  { label: "Guinea", value: "GN" },
  { label: "Guinea-Bissau", value: "GW" },
  { label: "Guyana", value: "GY" },
  { label: "Haiti", value: "HT" },
  { label: "Heard Island and McDonald Islands", value: "HM" },
  { label: "Holy See (Vatican City State)", value: "VA" },
  { label: "Honduras", value: "HN" },
  { label: "Hong Kong", value: "HK" },
  { label: "Hungary", value: "HU" },
  { label: "Iceland", value: "IS" },
  { label: "India", value: "IN" },
  { label: "Indonesia", value: "ID" },
  { label: "Iran, Islamic Republic of", value: "IR" },
  { label: "Iraq", value: "IQ" },
  { label: "Ireland", value: "IE" },
  { label: "Isle of Man", value: "IM" },
  { label: "Israel", value: "IL" },
  { label: "Italy", value: "IT" },
  { label: "Jamaica", value: "JM" },
  { label: "Japan", value: "JP" },
  { label: "Jersey", value: "JE" },
  { label: "Jordan", value: "JO" },
  { label: "Kazakhstan", value: "KZ" },
  { label: "Kenya", value: "KE" },
  { label: "Kiribati", value: "KI" },
  { label: "Korea, Democratic People's Republic of", value: "KP" },
  { label: "Korea, Republic of", value: "KR" },
  { label: "Kuwait", value: "KW" },
  { label: "Kyrgyzstan", value: "KG" },
  { label: "Lao People's Democratic Republic", value: "LA" },
  { label: "Latvia", value: "LV" },
  { label: "Lebanon", value: "LB" },
  { label: "Lesotho", value: "LS" },
  { label: "Liberia", value: "LR" },
  { label: "Libya", value: "LY" },
  { label: "Liechtenstein", value: "LI" },
  { label: "Lithuania", value: "LT" },
  { label: "Luxembourg", value: "LU" },
  { label: "Macao", value: "MO" },
  { label: "Macedonia, the Former Yugoslav Republic of", value: "MK" },
  { label: "Madagascar", value: "MG" },
  { label: "Malawi", value: "MW" },
  { label: "Malaysia", value: "MY" },
  { label: "Maldives", value: "MV" },
  { label: "Mali", value: "ML" },
  { label: "Malta", value: "MT" },
  { label: "Marshall Islands", value: "MH" },
  { label: "Martinique", value: "MQ" },
  { label: "Mauritania", value: "MR" },
  { label: "Mauritius", value: "MU" },
  { label: "Mayotte", value: "YT" },
  { label: "Mexico", value: "MX" },
  { label: "Micronesia, Federated States of", value: "FM" },
  { label: "Moldova, Republic of", value: "MD" },
  { label: "Monaco", value: "MC" },
  { label: "Mongolia", value: "MN" },
  { label: "Montenegro", value: "ME" },
  { label: "Montserrat", value: "MS" },
  { label: "Morocco", value: "MA" },
  { label: "Mozambique", value: "MZ" },
  { label: "Myanmar", value: "MM" },
  { label: "Namibia", value: "NA" },
  { label: "Nauru", value: "NR" },
  { label: "Nepal", value: "NP" },
  { label: "Netherlands", value: "NL" },
  { label: "New Caledonia", value: "NC" },
  { label: "New Zealand", value: "NZ" },
  { label: "Nicaragua", value: "NI" },
  { label: "Niger", value: "NE" },
  { label: "Nigeria", value: "NG" },
  { label: "Niue", value: "NU" },
  { label: "Norfolk Island", value: "NF" },
  { label: "Northern Mariana Islands", value: "MP" },
  { label: "Norway", value: "NO" },
  { label: "Oman", value: "OM" },
  { label: "Pakistan", value: "PK" },
  { label: "Palau", value: "PW" },
  { label: "Palestine, State of", value: "PS" },
  { label: "Panama", value: "PA" },
  { label: "Papua New Guinea", value: "PG" },
  { label: "Paraguay", value: "PY" },
  { label: "Peru", value: "PE" },
  { label: "Philippines", value: "PH" },
  { label: "Pitcairn", value: "PN" },
  { label: "Poland", value: "PL" },
  { label: "Portugal", value: "PT" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Qatar", value: "QA" },
  { label: "Réunion", value: "RE" },
  { label: "Romania", value: "RO" },
  { label: "Russian Federation", value: "RU" },
  { label: "Rwanda", value: "RW" },
  { label: "Saint Barthélemy", value: "BL" },
  { label: "Saint Helena, Ascension and Tristan da Cunha", value: "SH" },
  { label: "Saint Kitts and Nevis", value: "KN" },
  { label: "Saint Lucia", value: "LC" },
  { label: "Saint Martin (French part)", value: "MF" },
  { label: "Saint Pierre and Miquelon", value: "PM" },
  { label: "Saint Vincent and the Grenadines", value: "VC" },
  { label: "Samoa", value: "WS" },
  { label: "San Marino", value: "SM" },
  { label: "Sao Tome and Principe", value: "ST" },
  { label: "Saudi Arabia", value: "SA" },
  { label: "Senegal", value: "SN" },
  { label: "Serbia", value: "RS" },
  { label: "Seychelles", value: "SC" },
  { label: "Sierra Leone", value: "SL" },
  { label: "Singapore", value: "SG" },
  { label: "Sint Maarten (Dutch part)", value: "SX" },
  { label: "Slovakia", value: "SK" },
  { label: "Slovenia", value: "SI" },
  { label: "Solomon Islands", value: "SB" },
  { label: "Somalia", value: "SO" },
  { label: "South Africa", value: "ZA" },
  { label: "South Georgia and the South Sandwich Islands", value: "GS" },
  { label: "South Sudan", value: "SS" },
  { label: "Spain", value: "ES" },
  { label: "Sri Lanka", value: "LK" },
  { label: "Sudan", value: "SD" },
  { label: "Suriname", value: "SR" },
  { label: "Svalbard and Jan Mayen", value: "SJ" },
  { label: "Swaziland", value: "SZ" },
  { label: "Sweden", value: "SE" },
  { label: "Switzerland", value: "CH" },
  { label: "Syrian Arab Republic", value: "SY" },
  { label: "Taiwan, Province of China", value: "TW" },
  { label: "Tajikistan", value: "TJ" },
  { label: "Tanzania, United Republic of", value: "TZ" },
  { label: "Thailand", value: "TH" },
  { label: "Timor-Leste", value: "TL" },
  { label: "Togo", value: "TG" },
  { label: "Tokelau", value: "TK" },
  { label: "Tonga", value: "TO" },
  { label: "Trinidad and Tobago", value: "TT" },
  { label: "Tunisia", value: "TN" },
  { label: "Turkey", value: "TR" },
  { label: "Turkmenistan", value: "TM" },
  { label: "Turks and Caicos Islands", value: "TC" },
  { label: "Tuvalu", value: "TV" },
  { label: "Uganda", value: "UG" },
  { label: "Ukraine", value: "UA" },
  { label: "United Arab Emirates", value: "AE" },
  { label: "United Kingdom", value: "GB" },
  { label: "United States", value: "US" },
  { label: "United States Minor Outlying Islands", value: "UM" },
  { label: "Uruguay", value: "UY" },
  { label: "Uzbekistan", value: "UZ" },
  { label: "Vanuatu", value: "VU" },
  { label: "Venezuela, Bolivarian Republic of", value: "VE" },
  { label: "Viet Nam", value: "VN" },
  { label: "Virgin Islands, British", value: "VG" },
  { label: "Virgin Islands, U.S.", value: "VI" },
  { label: "Wallis and Futuna", value: "WF" },
  { label: "Western Sahara", value: "EH" },
  { label: "Yemen", value: "YE" },
  { label: "Zambia", value: "ZM" },
  { label: "Zimbabwe", value: "ZW" },
];

export default {
  data() {
    return {
      user: this.$store.state.user,
      role: this.$store.state.role,
      name: this.$store.state.user.name,
      firstname: this.$store.state.user.name.split(" ")[0],
      lastname: this.$store.state.user.name.replace(
        this.$store.state.user.name.split(" ")[0] + " ",
        ""
      ),
      email: this.$store.state.user.email,
      username: this.$store.state.user.username,
      password: "",
      password_new: "",
      password_new_repeat: "",
      matcherror: false,
      passworderror: false,
      telephone: this.$store.state.user.telephone,
      avatar: this.$store.state.user.avatar,
      continues_download_notification:
        this.$store.state.user.continues_download_notification,
      download_notification: this.$store.state.user.download_notification,
      company: this.$store.state.company,
      company_full: this.$store.state.company_full,
      company_name:
        this.$store.state.user.companyname &&
        this.$store.state.user.companyname !== "null"
          ? this.$store.state.user.companyname
          : "",
      company_address:
        this.$store.state.user.address &&
        this.$store.state.user.address !== "null"
          ? this.$store.state.user.address
          : "",
      company_country: this.$store.state.user.country,
      company_field: this.$store.state.user.field,
      file: null,
      url: null,
      success1: false,
      working1: false,
      success2: false,
      working2: false,
      showPassword: false,
      loading: false,
      loginInfoError: false,
      nameInfoError: false,
      showComponyFields: false,
      company_field_selected: company_fields.filter(
        (field) => field.value === this.$store.state.user.field
      )[0]
        ? company_fields.filter(
            (field) => field.value === this.$store.state.user.field
          )[0].label
        : "",
      company_fields: company_fields,
      showCountry_fields: false,
      country_field_selected: countries.filter(
        (field) => field.value === this.$store.state.user.country
      )[0]
        ? countries.filter(
            (field) => field.value === this.$store.state.user.country
          )[0].label
        : "",
      country_fields: countries,
    };
  },
  created() {
    //   EventBus.$on("keypress", (key) => this.selectCountry(key));
  },
  beforeMount() {
    if (this.$store.state.user == null) {
      //no user so redirect to login
      this.$router.push(`/${this.$store.state.company}`);
    }

    if (this.$store.state.user.name == "null") {
      this.name = "";
    } else {
      this.name = this.$store.state.user.name;
    }

    this.email = this.$store.state.user.email;

    if (this.$store.state.user.telephone == "null") {
      this.telephone = "";
    } else {
      this.telephone = this.$store.state.user.telephone;
    }

    this.avatar = this.$store.state.user.avatar;
    this.company = this.$store.state.company;
  },
  methods: {
    selectCountry(key) {
      if (this.showCountry_fields) {
        let elemId = false;

        //is open so select based on key
        Object.keys(countries).forEach((countryKey) => {
          const country = countries[countryKey];

          if (country.label[0].toLowerCase() === key && !elemId) {
            elemId = country.label;
          }
        });

        if (elemId) {
          this.$scrollTo(`#${elemId}`, 300, { container: "#company-field" });
        }
      }
    },
    getUsedPercentage() {
      // convert to MB
      let usedMb = this.company_full.usage * 1048576; // bytes to mb
      let totalMb = this.company_full.plan.size * 1048576; // bytes to mb

      return (usedMb / totalMb) * 100;
    },
    handleFiles(e) {
      this.file = this.$refs.files.files[0];

      // const fileupload = this.$refs.files.files[0];
      this.url = URL.createObjectURL(this.file);
    },
    setCompanyField(label, value) {
      this.company_field = value;
      this.company_field_selected = label;
      this.showComponyFields = false;
    },
    setCountryField(label, value) {
      this.company_country = value;
      this.country_field_selected = label;
      this.showCountry_fields = false;
    },
    setCountryOptions() {
      return this.country_fields.map((country) => {
        return {
          name: country.label,
          func: () => this.setCountryField(country.label, country.value),
        };
      });
    },
    setCompanyOptions() {
      return this.company_fields.map((company) => {
        return {
          name: company.label,
          func: () => this.setCompanyField(company.label, company.value),
        };
      });
    },
    submit(place) {
      this.success1 = false;
      this.success2 = false;
      this.loginInfoError = false;
      this.nameInfoError = false;
      event.preventDefault();
      if (place === 3) {
        //delete user
        //user data?

        EventBus.$emit(`right-sidebar-show`, {
          id: "userDelete",
          data: this.$store.state.user,
        });
      } else {
        if (this.password_new != this.password_new_repeat) {
          this.matcherror = true;
        } else {
          if (place === 1) {
            this.working1 = true;
          }
          if (place === 2) {
            this.working2 = true;
          }

          let formData = new FormData();
          formData.append("name", this.firstname + " " + this.lastname);
          formData.append("username", this.username);
          formData.append("email", this.email);
          formData.append("avatar", this.file);
          formData.append("password", this.password);
          formData.append("password_new", this.password_new);
          formData.append("password_new_repeat", this.password_new_repeat);
          formData.append("telephone", this.telephone);
          formData.append("company_name", this.company_name);
          formData.append("company_address", this.company_address);
          formData.append("company_country", this.company_country);
          formData.append("company_field", this.company_field);
          formData.append("download_notification", this.download_notification);
          formData.append(
            "continues_download_notification",
            this.continues_download_notification
          );

          this.$axios
            .post(baseUrl + "/userupdate", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              if (response.data.success) {
                let that = this;
                if (place === 1) {
                  setTimeout(function () {
                    that.working1 = false;
                    that.success1 = true;
                    setTimeout(() => (that.success1 = false), 3000);
                  }, 1000);
                }
                if (place === 2) {
                  setTimeout(function () {
                    that.working2 = false;
                    that.success2 = true;
                    setTimeout(() => (that.success2 = false), 3000);
                  }, 1000);
                }
                this.$store.state.user = response.data;
                this.user = response.data;
                this.$axios.defaults.params["email"] = response.data.email;
                this.$axios.defaults.params["key"] = response.data.key;
                localStorage.setItem(
                  this.$store.state.company + "_" + "user",
                  JSON.stringify(response.data)
                );
                EventBus.$emit("login");
                // this.$router.push("/"+this.$store.state.company+"/home");
              } else {
                let that = this;
                setTimeout(function () {
                  that.working1 = false;
                  that.working2 = false;
                  if (response.data.msg === "password_incorrect") {
                    that.passworderror = true;
                  }
                  if (response.data.msg === "name_invalid") {
                    that.nameInfoError = true;
                  }
                  if (response.data.msg === "duplicate") {
                    that.loginInfoError = true;
                  }
                }, 1000);
              }
            })
            .catch((thrown) => {
              this.error = "Something went wrong.";
            });
        }
      }
    },
    goTo(route) {
      this.$router.push(route);
      this.show = false;
    },
  },
  mounted() {
    /*let self = this;
    setTimeout(() => {
      this.loading = false;
    }, 1000);*/
  },
};
